import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LanguageStateType = {
  language: string;
  generatedDate: string;
  keyValues: any;
  inspectionSidebarLanguagePack: {
    language: string;
    generatedDate: string;
    keyValues: any;
  };
};
// initial state of Language pack
const initialState: LanguageStateType = {
  language: '',
  generatedDate: '',
  keyValues: {},
  inspectionSidebarLanguagePack: {
    language: '',
    generatedDate: '',
    keyValues: {},
  },
};

// eslint-disable-next-line no-extend-native
String.prototype.toLanguagePack = function (): string {
  const key = String(this);
  return key;
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    // reset the state
    resetLanguage: () => initialState,
    // update the initial state of Language

    updateLanguagePack: (
      state: LanguageStateType,
      action: PayloadAction<any>
    ) => {
      const { GeneratedDate, KeyValues, language } = action.payload;
      state.generatedDate = GeneratedDate;
      state.keyValues = KeyValues;

      if (language) {
        state.language = language;
      }
    },
    updateInspectionSidebarLanguagePack: (
      state: LanguageStateType,
      action: PayloadAction<any>
    ) => {
      const { GeneratedDate, KeyValues, language } = action.payload;
      state.inspectionSidebarLanguagePack.generatedDate = GeneratedDate;
      state.inspectionSidebarLanguagePack.keyValues = KeyValues;

      if (language) {
        state.inspectionSidebarLanguagePack.language = language;
      }
    },
  },
});

export const {
  updateLanguagePack,
  resetLanguage,
  updateInspectionSidebarLanguagePack,
} = languageSlice.actions;
export default languageSlice.reducer;
